var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "default-layout",
    [
      _c(
        "SpainhnNavigationBreadcrumb",
        { attrs: { "navigation-links": _vm.links } },
        [
          _vm._t("default", function () {
            return [
              _c(
                "svg",
                {
                  staticClass: "mx-1 my-auto",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "2",
                    height: "14",
                    viewBox: "0 0 2 14",
                    fill: "none",
                  },
                },
                [_c("path", { attrs: { d: "M1 0V13.5", stroke: "white" } })]
              ),
              _c(
                "small",
                {
                  staticClass:
                    "spainhn-small-text text-white my-auto px-1 variable-item",
                  class: {
                    "d-none": _vm.experiencias == 0,
                    "d-inline-block": _vm.experiencias,
                  },
                  attrs: { role: "button" },
                  on: { click: _vm.goToExperiences },
                },
                [_vm._v(_vm._s(_vm.$t("default.SERVICES_BAR_EXPERIENCES")))]
              ),
              _c(
                "svg",
                {
                  staticClass: "mx-1 my-auto",
                  class: { "d-none": _vm.experiencias == 0 },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "2",
                    height: "14",
                    viewBox: "0 0 2 14",
                    fill: "none",
                  },
                },
                [_c("path", { attrs: { d: "M1 0V13.5", stroke: "white" } })]
              ),
              _c(
                "small",
                {
                  staticClass:
                    "spainhn-small-text text-white my-auto px-1 variable-item",
                  class: { "d-none": !_vm.bodas },
                  attrs: { role: "button" },
                  on: { click: _vm.goToBodas },
                },
                [_vm._v(_vm._s(_vm.$t("default.SERVICES_BAR_WEDDING")))]
              ),
              _c(
                "svg",
                {
                  staticClass: "mx-1 my-auto",
                  class: { "d-none": _vm.bodas == 0 },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "2",
                    height: "14",
                    viewBox: "0 0 2 14",
                    fill: "none",
                  },
                },
                [_c("path", { attrs: { d: "M1 0V13.5", stroke: "white" } })]
              ),
              _c(
                "small",
                {
                  staticClass:
                    "spainhn-small-text text-white my-auto px-1 variable-item",
                  class: { "d-none": !_vm.espacios },
                  attrs: { role: "button" },
                  on: { click: _vm.goToEspacios },
                },
                [_vm._v(_vm._s(_vm.$t("default.SERVICES_BAR_SPACES")))]
              ),
              _c(
                "svg",
                {
                  staticClass: "mx-1 my-auto",
                  class: { "d-none": _vm.espacios == 0 },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "2",
                    height: "14",
                    viewBox: "0 0 2 14",
                    fill: "none",
                  },
                },
                [_c("path", { attrs: { d: "M1 0V13.5", stroke: "white" } })]
              ),
              _c(
                "small",
                {
                  staticClass:
                    "spainhn-small-text text-white my-auto px-1 variable-item",
                  class: { "d-none": !_vm.museo },
                  attrs: { role: "button" },
                  on: { click: _vm.goToMuseo },
                },
                [_vm._v(_vm._s(_vm.$t("default.SERVICES_BAR_MUSEUM")))]
              ),
              _c(
                "svg",
                {
                  staticClass: "mx-1 my-auto",
                  class: { "d-none": _vm.museo == 0 },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "2",
                    height: "14",
                    viewBox: "0 0 2 14",
                    fill: "none",
                  },
                },
                [_c("path", { attrs: { d: "M1 0V13.5", stroke: "white" } })]
              ),
              _c(
                "small",
                {
                  staticClass:
                    "spainhn-small-text text-white my-auto px-1 variable-item",
                  class: { "d-none": !_vm.restaurante },
                  attrs: { role: "button" },
                  on: { click: _vm.goToRestaurante },
                },
                [_vm._v(_vm._s(_vm.$t("default.SERVICES_BAR_RESTAURANT")))]
              ),
              _c(
                "svg",
                {
                  staticClass: "mx-1 my-auto",
                  class: { "d-none": _vm.restaurante == 0 },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "2",
                    height: "14",
                    viewBox: "0 0 2 14",
                    fill: "none",
                  },
                },
                [_c("path", { attrs: { d: "M1 0V13.5", stroke: "white" } })]
              ),
              _c(
                "small",
                {
                  staticClass:
                    "spainhn-small-text text-white my-auto px-1 variable-item",
                  class: { "d-none": !_vm.alojamiento },
                  attrs: { role: "button" },
                  on: { click: _vm.goToAlojamiento },
                },
                [_vm._v(_vm._s(_vm.$t("default.SERVICES_BAR_ACCOMMODATION")))]
              ),
              _c(
                "svg",
                {
                  staticClass: "mx-1 my-auto",
                  class: { "d-none": _vm.alojamiento == 0 },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "2",
                    height: "14",
                    viewBox: "0 0 2 14",
                    fill: "none",
                  },
                },
                [_c("path", { attrs: { d: "M1 0V13.5", stroke: "white" } })]
              ),
              _c(
                "small",
                {
                  staticClass:
                    "spainhn-small-text text-white my-auto px-1 flex-grow-1 text-start variable-item",
                  attrs: { role: "button" },
                  on: { click: _vm.goToContact },
                },
                [_vm._v(_vm._s(_vm.$t("default.SERVICES_BAR_CONTACT")))]
              ),
            ]
          }),
        ],
        2
      ),
      _c("white-loader", { attrs: { loading: _vm.loading } }),
      _c(
        "div",
        {
          staticClass:
            "container-fluid px-2 px-md-5 margen-estandard mergen-cards",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-around pt-2 mb-2 px-lg-4 flex-column",
            },
            [
              _vm.agrupacionInfo && _vm.agrupacionInfo.length > 1
                ? _c(
                    "div",
                    { staticClass: "monumentos-tabs" },
                    [
                      _c(
                        "b-tabs",
                        {
                          attrs: {
                            "content-class": "mt-2",
                            "nav-class": "custom-tabs",
                            "active-nav-item-class": "custom-active-tab",
                          },
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.agrupacionInfo, function (monumento) {
                          return _c("b-tab", {
                            key: monumento._id,
                            attrs: {
                              title: monumento.nombre,
                              active: monumento._id === _vm.castilloId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleTabClick(monumento)
                              },
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex px-lg-4 mt-4" },
                [
                  _c(
                    "icon-base",
                    {
                      attrs: {
                        width: 12,
                        height: 12,
                        iconColor: "rgb(0,0,0)",
                        id: "icono-castillo",
                      },
                    },
                    [_c("icon-casttle")],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "ms-3 h-100 d-flex flex-column text-start" },
                    [
                      _c("p", {
                        staticClass:
                          "mb-0 mt-auto pb-0 spainhn-subtitle-2-black",
                        domProps: {
                          innerHTML: _vm._s(_vm.nombreDeMonumentoPorIdioma),
                        },
                      }),
                      _c(
                        "small",
                        {
                          staticClass:
                            "mb-0 mt-0 spainhn-subtitle-4-black pt-0",
                        },
                        [_vm._v(_vm._s(_vm.address))]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "container-fluid px-0" }, [
            _c("div", { staticClass: "row ps-lg-4 pe-0 gx-2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "text-start spainhn-text pt-0 pe-0 mb-1 mb-md-5 col-xxl-8 col-12 px-0",
                  staticStyle: { height: "100%" },
                },
                [
                  _c(
                    "b-carousel",
                    {
                      staticStyle: { "text-shadow": "1px 1px 2px #333" },
                      attrs: {
                        id: "monumentosShow",
                        interval: 4000,
                        controls: "",
                        indicators: "",
                        "img-width": "940",
                        "img-height": "528",
                      },
                      on: {
                        "sliding-start": _vm.onSlideStart,
                        "sliding-end": _vm.onSlideEnd,
                      },
                      model: {
                        value: _vm.slide,
                        callback: function ($$v) {
                          _vm.slide = $$v
                        },
                        expression: "slide",
                      },
                    },
                    [
                      _vm._l(_vm.imagenes, function (imagen, index) {
                        return _c("b-carousel-slide", {
                          key: index,
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "img",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mb-3 d-flex mx-auto carousel-homeslide px-0 mx-0",
                                        staticStyle: {
                                          height: "344px",
                                          width: "940px",
                                          "max-width": "100%",
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "my-md-auto mx-auto carousel-spainhn",
                                          staticStyle: {
                                            height: "auto",
                                            width: "auto",
                                            "max-width": "940px",
                                            "max-height": "344px",
                                            display: "block",
                                          },
                                          attrs: {
                                            src: `${_vm.imagenesUrl}/monumentos/${_vm.monumentoOldId}/${imagen.name}`,
                                            alt: imagen.altText,
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-prev",
                          attrs: {
                            "aria-controls": "monumentosShow___BV_inner_",
                            role: "button",
                            "data-slide": "prev",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "text-black",
                            attrs: { icon: "fa-circle", size: "3x" },
                          }),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Previous"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "carousel-control-next",
                          attrs: {
                            role: "button",
                            "data-slide": "next",
                            "aria-controls": "monumentosShow___BV_inner_",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "text-black",
                            attrs: { icon: "fa-circle", size: "3x" },
                          }),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Previous"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "overflow-hidden mx-auto mt-2 d-md-block d-none",
                      staticStyle: {
                        height: "94.5px",
                        width: "940px",
                        "max-width": "100%",
                        position: "relative",
                      },
                      attrs: { id: "imageSelectorContainer" },
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "imageSelector",
                          staticClass: "d-flex thumbnails-container",
                          staticStyle: {
                            height: "94.5px",
                            width: "940px",
                            "max-width": "72vw",
                            position: "relative",
                          },
                          attrs: { id: "imageSelector" },
                        },
                        _vm._l(_vm.imagenes, function (imagen, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "thumbnail-slide",
                              staticStyle: { height: "94.5px", width: "140px" },
                            },
                            [
                              _c("img", {
                                staticClass: "px-1",
                                staticStyle: {
                                  height: "100%",
                                  width: "140px",
                                  "object-fit": "cover",
                                  "border-radius": "15px",
                                },
                                attrs: {
                                  role: "button",
                                  src: `${_vm.imagenesUrl}/monumentos/${_vm.monumentoOldId}/${imagen.name}`,
                                  alt: imagen.altText,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeSlide(index)
                                  },
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-around pt-0 pt-md-2 mb-0 px-lg-2 px-md-0 mx-auto",
                      staticStyle: { padding: "0 15px 0 15px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex px-lg-4 align-middle",
                          staticStyle: {
                            width: "100%",
                            position: "relative",
                            "min-height": "54px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ms-md-auto ms-lg-0 mb-auto icon-container",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "100",
                                    height: "100",
                                    viewBox: "0 0 31 25",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M30.4841 24.491C30.4695 24.491 30.455 24.491 30.4404 24.491H28.8407L27.5754 10.6021V10.5876V8.26062H28.608C28.7534 8.26062 28.8698 8.14427 28.8698 7.99884V5.42467C28.8698 5.27923 28.7534 5.16289 28.608 5.16289H27.3136C27.1682 5.16289 27.0518 5.27923 27.0518 5.42467V6.45724H26.281V4.13031C26.281 3.98487 26.1647 3.86853 26.0193 3.86853H23.7069V2.99593L26.1356 1.77429C26.2665 1.70157 26.3101 1.55614 26.252 1.42525C26.2229 1.38162 26.1938 1.33799 26.1356 1.3089L23.5905 0.04363L23.5614 0.0290867C23.5469 0.0145433 23.5324 0.0145433 23.5178 0.0145433C23.5178 0.0145433 23.5033 0.0145433 23.5033 0C23.4887 0 23.4596 0 23.4451 0C23.4306 0 23.4306 0 23.416 0C23.4015 0 23.3869 0 23.3724 0H23.3578C23.3433 0 23.3287 0.0145433 23.3287 0.0145433C23.3142 0.0145433 23.2997 0.0290867 23.2997 0.04363C23.2851 0.04363 23.2851 0.0581734 23.2706 0.0727167C23.2706 0.0727167 23.256 0.101803 23.2415 0.116347C23.2415 0.116347 23.2415 0.13089 23.2269 0.13089V0.145433C23.2269 0.145433 23.2269 0.159977 23.2269 0.17452C23.2269 0.189063 23.2269 0.203607 23.2269 0.21815V0.232693V3.83944H22.1944C22.0489 3.83944 21.9326 3.95579 21.9326 4.10122V6.42816H21.1618V5.39558C21.1472 5.25015 21.0309 5.14834 20.8855 5.16289H19.6057C19.4602 5.16289 19.3439 5.27923 19.3439 5.41012V7.98429C19.3439 8.12973 19.4602 8.24607 19.5911 8.24607H20.6237V10.5585L20.2892 14.1798H15.9989V13.1908C15.9989 13.1763 15.9989 13.1763 15.9989 13.1617V13.1326C15.9989 13.1181 15.9989 13.1035 15.9844 13.089V13.0745C15.9844 13.0599 15.9698 13.0454 15.9698 13.0308L15.9553 13.0017L14.69 10.4712C14.6173 10.3403 14.4428 10.2967 14.3264 10.3839C14.2828 10.413 14.2537 10.4421 14.2392 10.4712L12.9739 13.0017C12.9739 13.0017 12.9739 13.0017 12.9593 13.0163L12.9448 13.0454C12.9303 13.0599 12.9303 13.0745 12.9303 13.1035C12.9303 13.1181 12.9303 13.1326 12.9303 13.1617V14.2088H9.87616L9.55621 10.5876V8.26062H10.5888C10.7342 8.26062 10.8506 8.14427 10.8506 7.99884V5.42467C10.8506 5.27923 10.7342 5.16289 10.5888 5.16289H9.30897C9.16354 5.16289 9.04719 5.27923 9.04719 5.42467V6.45724H8.27639V5.42467C8.27639 5.27923 8.16005 5.16289 8.02916 5.16289H6.7348C6.58937 5.16289 6.47302 5.27923 6.47302 5.42467V6.45724H5.70222V5.42467C5.70222 5.27923 5.58588 5.16289 5.44044 5.16289H4.14608C4.00065 5.16289 3.8843 5.27923 3.8843 5.42467V6.45724H3.11351V5.42467C3.11351 5.27923 2.99716 5.16289 2.85173 5.16289H1.55737C1.41194 5.16289 1.29559 5.27923 1.29559 5.42467V7.99884C1.29559 8.14427 1.41194 8.26062 1.55737 8.26062H2.58995V10.5585L1.32468 24.4764H0.277556C0.132123 24.4619 0.015776 24.5782 0.00123267 24.7091C-0.0133107 24.84 0.103036 24.9709 0.233926 24.9855C0.248469 24.9855 0.263013 24.9855 0.277556 24.9855H1.51374C1.52828 24.9855 1.52828 24.9855 1.54283 24.9855H1.57191C1.58646 24.9855 1.601 24.9855 1.63009 24.9855H10.5597C10.5742 24.9855 10.5742 24.9855 10.5888 24.9855H24.7685C24.7831 24.9855 24.7831 24.9855 24.7976 24.9855H30.4695C30.615 25 30.7313 24.8837 30.7459 24.7528C30.7604 24.6219 30.6295 24.491 30.4841 24.491ZM23.7214 0.69808L25.4666 1.57068L23.7214 2.44328V0.69808ZM21.1472 10.3258V8.26062H27.0809V10.3258H21.1472ZM22.4416 4.39209H25.7866V5.16289H24.754C24.6086 5.16289 24.4922 5.27923 24.4922 5.42467V6.45724H23.7214V5.42467C23.7214 5.27923 23.6051 5.16289 23.4742 5.16289H22.4416V4.39209ZM19.8529 7.7516V5.68645H20.6237V6.71902C20.6237 6.86446 20.74 6.9808 20.8855 6.9808H22.1798C22.3253 6.9808 22.4416 6.86446 22.4416 6.71902V5.68645H23.2269V6.71902C23.2269 6.86446 23.3433 6.9808 23.4887 6.9808H24.7831C24.9285 6.9808 25.0449 6.86446 25.0449 6.71902V5.68645H25.8157V6.71902C25.8157 6.86446 25.932 6.9808 26.0774 6.9808H27.3718C27.5172 6.9808 27.6336 6.86446 27.6336 6.71902V5.68645H28.4044L28.3607 7.7516H19.8529ZM14.4573 11.1547L15.3299 12.8999H13.5847L14.4573 11.1547ZM13.4247 13.409H15.4899V15.4887H13.4247V14.7179V14.2088V13.409ZM12.9012 14.7179V15.7359C12.9012 15.8813 13.0175 15.9977 13.163 15.9977H15.7371C15.8826 15.9977 15.9989 15.8813 15.9844 15.7359V14.7179H21.9908L23.0961 18.0628H22.1362C22.1217 18.0628 22.1071 18.0628 22.0926 18.0628C22.078 18.0628 22.0635 18.0628 22.0489 18.0628H10.2397L9.93433 14.7179H12.9012ZM23.7214 20.8842V19.8662H24.4922V24.491H10.8215L10.5161 21.146C10.5452 21.146 10.5597 21.146 10.5888 21.146H22.0489C22.0635 21.146 22.0926 21.146 22.1071 21.146C22.1217 21.146 22.1507 21.146 22.1653 21.146H23.4742C23.6051 21.1315 23.7214 21.0151 23.7214 20.8842ZM13.4247 20.6225V20.2298C13.4247 20.0116 13.5993 19.8517 13.8174 19.8517C14.0356 19.8517 14.2101 20.0262 14.2101 20.2298V20.6225H13.4247ZM15.9989 20.6225V20.2298C16.0134 20.0116 16.2025 19.8517 16.4061 19.8662C16.5952 19.8807 16.7552 20.0407 16.7697 20.2298V20.6225H15.9989ZM18.5731 20.6225V20.2298C18.5876 20.0116 18.7767 19.8517 18.9803 19.8662C19.1694 19.8807 19.3293 20.0407 19.3439 20.2298V20.6225H18.5731ZM19.8674 20.637V20.2589C19.8674 19.7644 19.4602 19.3572 18.9657 19.3572C18.4713 19.3572 18.0641 19.7644 18.0641 20.2589V20.637H17.2933V20.2589C17.2933 19.7644 16.886 19.3572 16.3916 19.3572C15.8971 19.3572 15.4899 19.7644 15.4899 20.2589V20.637H14.7191V20.2589C14.7045 19.7644 14.2828 19.3717 13.7738 19.3863C13.3084 19.4008 12.9303 19.7789 12.9012 20.2589V20.637H10.5742C10.5306 20.637 10.5015 20.6515 10.4579 20.6661L10.2688 18.5864H21.8308V20.637H19.8674ZM1.81915 7.7516V5.68645H2.58995V6.71902C2.58995 6.86446 2.70629 6.9808 2.85173 6.9808H4.14608C4.29152 6.9808 4.40786 6.86446 4.40786 6.71902V5.68645H5.17866V6.71902C5.17866 6.86446 5.29501 6.9808 5.44044 6.9808H6.7348C6.88023 6.9808 6.99658 6.86446 6.99658 6.71902V5.68645H7.76738V6.71902C7.76738 6.86446 7.88372 6.9808 8.01461 6.9808H9.30897C9.4544 6.9808 9.57075 6.86446 9.57075 6.71902V5.68645H10.327V7.7516H1.81915ZM9.03265 8.26062V10.3258H3.11351V8.26062H9.03265ZM3.08442 10.8348H9.06173L9.36714 14.1798L9.41077 14.6888L10.2979 24.4764H1.84824L3.08442 10.8348ZM25.0158 24.491V19.6044C25.0158 19.459 24.8994 19.3572 24.754 19.3572H23.4596C23.3142 19.3572 23.1979 19.4735 23.1979 19.619V20.6515H22.3398V18.6009H23.4306C23.5178 18.6009 23.5905 18.5573 23.6487 18.4846C23.6923 18.4119 23.7069 18.3246 23.6778 18.2519L22.398 14.3834C22.3689 14.2816 22.2671 14.2088 22.1507 14.2088H20.7982L21.1036 10.8493H27.0809L28.3171 24.491H25.0158Z",
                                      fill: "#850B0B",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M4.786 11.6056C4.29152 11.6056 3.88431 12.0128 3.88431 12.5073V14.4415C3.88431 14.587 4.00065 14.7033 4.13154 14.7033H5.4259C5.57134 14.7033 5.68768 14.587 5.68768 14.4415V12.5073C5.68768 12.0128 5.28047 11.6056 4.786 11.6056ZM5.17866 14.1943H4.40787V12.5073C4.40787 12.2891 4.58239 12.1146 4.80054 12.1146C5.01869 12.1146 5.19321 12.2891 5.19321 12.5073V14.1943H5.17866Z",
                                      fill: "#850B0B",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M8.26184 16.3758C8.26184 15.8813 7.85463 15.4741 7.36015 15.4741C6.86568 15.4741 6.45847 15.8813 6.45847 16.3758V18.3101C6.45847 18.4555 6.57481 18.5719 6.72025 18.5719H8.00006C8.14549 18.5719 8.26184 18.4555 8.26184 18.3246V16.3758ZM6.98203 18.0483V16.3758C6.99657 16.1577 7.18563 15.9977 7.38924 16.0122C7.5783 16.0268 7.73828 16.1867 7.75282 16.3758V18.0483H6.98203Z",
                                      fill: "#850B0B",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M25.3939 11.6056C24.8994 11.6056 24.4922 12.0128 24.4922 12.5073V14.4415C24.4922 14.587 24.6086 14.7033 24.754 14.7033H26.0338C26.1792 14.7033 26.2956 14.587 26.2956 14.4415V12.5073C26.2956 12.0128 25.9029 11.6056 25.3939 11.6056ZM25.7866 14.1943H25.0158V12.5073C25.0158 12.2891 25.1903 12.1146 25.4084 12.1146C25.6266 12.1146 25.8011 12.2891 25.8011 12.5073V14.1943H25.7866Z",
                                      fill: "#850B0B",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "ms-3 d-flex flex-column text-start me-md-auto me-lg-0 mt-1",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "mb-0 pb-0 spainhn-header-info",
                                },
                                [_vm._v(_vm._s(_vm.nombreDeMonumentoPorIdioma))]
                              ),
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 mt-0 spainhn-subheader-info pt-0",
                                },
                                [_vm._v(_vm._s(_vm.address))]
                              ),
                            ]
                          ),
                          _c("buy-component", {
                            attrs: { pulse: "" },
                            on: { goTo: _vm.goToEntradas },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-xxl-4 tickets-wrapper d-none d-lg-inline-block",
                  staticStyle: { "min-height": "450px" },
                },
                [
                  _c("div", { staticClass: "row h-100 pt-0 w-100 mx-auto" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 col-12 mb-2 mx-auto" },
                      [
                        _c(
                          "GmapMap",
                          {
                            staticClass: "mx-auto",
                            staticStyle: {
                              width: "100%",
                              height: "249px",
                              "max-width": "90vw",
                            },
                            attrs: {
                              center: { lat: _vm.latitud, lng: _vm.longitud },
                              zoom: 9.7,
                              "map-type-id": "terrain",
                            },
                          },
                          _vm._l(_vm.markers, function (m, index) {
                            return _c("GmapMarker", {
                              key: index,
                              attrs: {
                                position: m.position,
                                clickable: true,
                                draggable: false,
                                icon: require("@/assets/marker-gral-small.png"),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.center = m.position
                                },
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-12 col-12 mb-2 mx-auto",
                        class: { "d-none": _vm.rutaInfo?.rutaId == null },
                      },
                      [
                        _c("h5", { staticClass: "spainhn-sections-title" }, [
                          _vm._v(_vm._s(_vm.$t("default.ROUTES_KNOW_ROUTES"))),
                        ]),
                        _c("RutasCard", {
                          staticClass: "mx-auto",
                          attrs: {
                            imageUrl: `${_vm.imagenesUrl}/rutas/logo/${_vm.rutaInfo?.rutaId}`,
                            title: _vm.rutaInfo?.webName,
                          },
                          on: { goToRutas: () => _vm.masRutas() },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "container-fluid ps-lg-4 pe-lg-3 cultural-visit" },
            [
              _c(
                "div",
                { staticClass: "row ps-lg-4 pe-lg-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-start spainhn-text pt-0 pe-3 col-12 col-xxl-8 order-0",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "mb-2 spainhn-sections-title text-uppercase",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("default.MICROSITES_DESCRIPTION"))
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "mt-2",
                          class: { "d-none": !_vm.audioguiaOn },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-light border p-2 mb-0 d-flex justify-content-center mx-auto align-items-center",
                              staticStyle: { "max-width": "100vw" },
                            },
                            [
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.$t("default.MENSAJE_AUDIOGUIA"))
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "d-flex px-2" },
                                [
                                  _c("b-img", {
                                    staticClass: "mx-auto my-auto",
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      role: "button",
                                      src: require("@/assets/audioguia-logo.png"),
                                    },
                                    on: { click: _vm.goToAudioguia },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "html-spacing mb-1",
                          class: { "html-container": !_vm.showFullText },
                        },
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.micrositeData.webDescription
                              ),
                            },
                          }),
                        ]
                      ),
                      _c("span", { class: { "d-none": !_vm.podcastOn } }, [
                        _c(
                          "div",
                          { staticClass: "bg-light border pt-0 px-2 pb-0" },
                          [
                            _c("p", [
                              _c("small", [
                                _vm._v(
                                  _vm._s(_vm.$t("default.MENSAJE_PODCAST")) +
                                    " " +
                                    _vm._s(_vm.nombreDeMonumentoPorIdioma)
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _c("iframe", {
                                attrs: {
                                  allowfullscreen: "",
                                  frameborder: "0",
                                  height: "40",
                                  loading: "lazy",
                                  scrolling: "no",
                                  src: _vm.podcastUrl,
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "d-flex mx-auto my-2" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "read-more-btn mx-auto spainhn-gray-background mb-1",
                            on: { click: () => _vm.toggleFullText() },
                          },
                          [
                            _c(
                              "span",
                              { class: { "d-none": _vm.showFullText } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("default.BUTTONS.READ_MORE"))
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { class: { "d-none": !_vm.showFullText } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("default.BUTTONS.READ_LESS"))
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "mdb-container",
                    { staticClass: "d-lg-none px-0 mx-0" },
                    [
                      _vm.micrositeData.webSchedules
                        ? _c("collapsable-element", {
                            staticClass: "my-2",
                            attrs: {
                              title: _vm.$t("default.MICROSITES_SCHEDULE"),
                              content: `<div style='font-size:12px;'>${_vm.zanitizeColorHTMLString(
                                _vm.micrositeData.webSchedules
                              )}</div>`,
                            },
                          })
                        : _vm._e(),
                      _c("collapsable-element", {
                        staticClass: "my-2",
                        attrs: {
                          id: "services-small",
                          title: _vm.$t("default.MICROSITES_LOCATION"),
                          content: `<div style='font-size: 12px;'><p><strong>${
                            _vm.address
                          }</strong></p>${_vm.zanitizeColorHTMLString(
                            _vm.micrositeData.webDirections
                          )}</div>`,
                        },
                      }),
                      _c(
                        "collapsable-element",
                        {
                          staticClass: "my-2",
                          attrs: {
                            "no-divide": "",
                            title: _vm.$t(
                              "default.MAIN_MENU_MINIMAP_POPOVER_SERVICES_TITLE"
                            ),
                          },
                        },
                        [
                          _vm.bodas
                            ? _c("hr", {
                                staticStyle: {
                                  color: "black",
                                  "margin-top": "0",
                                },
                              })
                            : _vm._e(),
                          _vm.bodas
                            ? _c("collapsable-element", {
                                staticClass: "my-2",
                                attrs: {
                                  title: _vm.$t(
                                    "default.MICROSITES_SERVICES_WEDDING_HEADER"
                                  ),
                                  content: `<div style='font-size: 12px; color:white;'>${_vm.zanitizeColorHTMLString(
                                    _vm.micrositeData.webWeddingDescription
                                  )}</div>`,
                                },
                              })
                            : _vm._e(),
                          _vm.alojamiento
                            ? _c("hr", {
                                staticStyle: {
                                  color: "black",
                                  "margin-top": "0",
                                },
                              })
                            : _vm._e(),
                          _vm.alojamiento
                            ? _c("collapsable-element", {
                                staticClass: "my-2",
                                attrs: {
                                  "no-divide": "",
                                  title: _vm.$t(
                                    "default.MICROSITES_SERVICES_ACCOMMODATION_HEADER"
                                  ),
                                  content: `<div style='font-size: 12px;'>${_vm.zanitizeColorHTMLString(
                                    _vm.micrositeData.webHostingDescription
                                  )}</div>`,
                                },
                              })
                            : _vm._e(),
                          _vm.espacios
                            ? _c("hr", {
                                staticStyle: {
                                  color: "black",
                                  "margin-top": "0",
                                },
                              })
                            : _vm._e(),
                          _vm.espacios
                            ? _c("collapsable-element", {
                                staticClass: "my-2",
                                attrs: {
                                  "no-divide": "",
                                  title: _vm.$t(
                                    "default.MICROSITES_SERVICES_RESERVE_SPACE_HEADER"
                                  ),
                                  content: `<div style='font-size: 12px;'>${_vm.zanitizeColorHTMLString(
                                    _vm.micrositeData.webMiceDescription
                                  )}</div>`,
                                },
                              })
                            : _vm._e(),
                          _vm.restaurante
                            ? _c("hr", {
                                staticStyle: {
                                  color: "black",
                                  "margin-top": "0",
                                },
                              })
                            : _vm._e(),
                          _vm.restaurante
                            ? _c("collapsable-element", {
                                staticClass: "my-2",
                                attrs: {
                                  "no-divide": "",
                                  title: _vm.$t(
                                    "default.MICROSITES_SERVICES_RESTAURANT_HEADER"
                                  ),
                                  content: `<div style='font-size: 12px;'>${_vm.zanitizeColorHTMLString(
                                    _vm.micrositeData.webRestauranteDescription
                                  )}</div>`,
                                },
                              })
                            : _vm._e(),
                          _vm.museo
                            ? _c("hr", {
                                staticStyle: {
                                  color: "black",
                                  "margin-top": "0",
                                },
                              })
                            : _vm._e(),
                          _vm.museo
                            ? _c("collapsable-element", {
                                staticClass: "my-2",
                                attrs: {
                                  "no-divide": "",
                                  title: _vm.$t(
                                    "default.MICROSITES_SERVICES_MUSEUM_HEADER"
                                  ),
                                  content: `<div style='font-size: 12px;'>${_vm.zanitizeColorHTMLString(
                                    _vm.micrositeData.webMuseumDescription
                                  )}</div>`,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("MultimediaComponent", {
                        staticClass: "text-center",
                        class: { "d-none": !_vm.videoId },
                        attrs: { "video-id": _vm.videoId },
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-center align-items-center",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "spainhn-sections-title text-uppercase",
                            },
                            [_vm._v(_vm._s(_vm.$t("default.MAIN_MENU_RUTAS")))]
                          ),
                          _c("RutasCard", {
                            attrs: {
                              imageUrl: `${_vm.imagenesUrl}/rutas/logo/${_vm.rutaInfo?.rutaId}`,
                              title: _vm.rutaInfo?.nombre,
                            },
                            on: { goToRutas: () => _vm.masRutas() },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column col-12 my-2 d-md-none" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "spainhn-sections-title text-uppercase",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("default.HOME_RESULTS_MAP_LABEL"))
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-wrap justify-content-center",
                        },
                        [
                          _c("mapa-card", {
                            attrs: {
                              latitud: _vm.latitud,
                              longitud: _vm.longitud,
                              markers: _vm.markers,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.eventosRecomendados.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column pt-3 col-12 col-xxl-4 order-xl-1 order-last",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "spainhn-sections-title text-uppercase",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "default.MICROSITES_TICKETS_RECOMMENDATIONS"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap justify-content-evenly px-0",
                            },
                            [
                              _vm._l(
                                _vm.paquetes.filter(
                                  (p) => p.tipo_de_paquete === "pack_monumentos"
                                ),
                                function (paqueteM) {
                                  return _c("recommendations-card", {
                                    key: paqueteM._id,
                                    staticClass: "my-2",
                                    attrs: {
                                      title: paqueteM.webName,
                                      showDefault: false,
                                      text: _vm.$t("default.CARDS.PLACE", {
                                        msg: paqueteM.monumentName,
                                      }),
                                      "price-description":
                                        paqueteM?.precioOrientativo
                                          ? _vm.$t("default.CARDS.START_FROM", {
                                              msg: _vm.getPrice(
                                                paqueteM.precioOrientativo
                                              ),
                                            })
                                          : "",
                                      "image-url": `${_vm.imagenesUrl}/paquetes_monumentos/${paqueteM.oldId}/${paqueteM.banner}`,
                                      showBuyButton: true,
                                    },
                                    on: {
                                      goTo: () =>
                                        _vm.goToMicrositioPaqueteMonumento({
                                          name: paqueteM.name,
                                          id: paqueteM._id,
                                        }),
                                      buy: () => _vm.goToBuy(paqueteM, true),
                                    },
                                  })
                                }
                              ),
                              _vm._l(
                                _vm.eventosRecomendados,
                                function (evento, index) {
                                  return _c("recommendations-card", {
                                    key: index,
                                    staticClass: "my-2",
                                    class: { "d-none": index > 2 },
                                    attrs: {
                                      title: evento.webName,
                                      nombreUrl: evento.visitaId,
                                      fecha: evento.fechas,
                                      tipo: "Entrada",
                                      imageUrl: `${_vm.imagenesUrl}/visitas_castillos/${evento.oldId}/${evento.imagen}`,
                                    },
                                    on: { goTo: _vm.goToEntrada },
                                  })
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "d-xxl-flex mx-auto flex-column pt-3 h-100 col-12 order-md-last col-xxl-4 d-none pe-0",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-grow spainhn-bg-gris-cajas ps-4 pe-4 mt-2 pt-3 d-flex flex-column text-start spainhn-text",
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass: "d-flex fw-bold",
                                  staticStyle: {
                                    "font-weight": "700",
                                    "font-size": "28pt",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("default.MICROSITES_LOCATION")
                                    )
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "spainhn-text" }, [
                                _vm._v(_vm._s(_vm.address)),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "spinhn-text text-start fw-bold",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("default.MICROSITES_INDICATIONS")
                                    ) + ":"
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "spinhn-text text-start" },
                                [
                                  _c("p", {
                                    staticStyle: {
                                      "font-family": "Montserrat !important",
                                      "font-size": "12pt !important",
                                      "font-weight": "400 !important",
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.micrositeData.webDirections
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "container-fluid px-lg-4 mb-4 services-wrap d-md-flex",
            },
            [
              _c("div", { staticClass: "row w-100 px-lg-4" }, [
                _c(
                  "div",
                  { staticClass: "pt-3 pe-3 col-12 order-md-first col-xxl-12" },
                  [
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "div",
                        { staticClass: "mt-3 text-start d-none d-lg-block" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "mb-0 pb-0 pt-2 spainhn-sections-title text-start text-uppercase",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("default.MICROSITES_SCHEDULE"))
                              ),
                            ]
                          ),
                          _c("div", {
                            staticClass: "w-100 mt-0 pt-0 mb-1",
                            staticStyle: {
                              height: "2vh",
                              "border-color":
                                "var(--spainhn-rojo-corporativo) !important",
                              "border-width": "medium !important",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "spinhn-text column-count-2 text-start",
                            },
                            [
                              _c("p", {
                                staticClass: "column-count-responsive",
                                staticStyle: { "line-height-step": "50vh" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.micrositeData.webSchedules
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm.bodas ||
                      _vm.alojamiento ||
                      _vm.espacios ||
                      _vm.restaurante ||
                      _vm.museo
                        ? _c("div", {
                            staticClass:
                              "w-100 mt-0 pt-0 mb-4 d-none d-lg-block",
                            staticStyle: {
                              height: "9vh",
                              "border-color":
                                "var(--spainhn-rojo-corporativo) !important",
                              "border-width": "medium !important",
                            },
                            attrs: { id: "services" },
                          })
                        : _vm._e(),
                      _vm.bodas ||
                      _vm.alojamiento ||
                      _vm.espacios ||
                      _vm.restaurante ||
                      _vm.museo
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mt-3 text-start d-none d-lg-block pt-0",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "mb-0 pb-0 mt-t spainhn-sections-title text-start text-uppercase",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "default.MICROSITES_OFFERED_SERVICES"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("div", {
                                staticClass: "w-100 mt-0 pt-0 mb-1",
                                staticStyle: {
                                  height: "2vh",
                                  "border-color":
                                    "var(--spainhn-rojo-corporativo) !important",
                                  "border-width": "medium !important",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start gap-3 flex-wrap align-content-center flex-wrap",
                                },
                                [
                                  _vm.bodas
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-2 spainhn-bg-gris-cajas html-container service-item",
                                          staticStyle: { "flex-basis": "49%" },
                                        },
                                        [
                                          _c("h5", { staticClass: "fw-bold" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "default.SERVICES.WEDDINGS"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.micrositeData
                                                  .webWeddingDescription
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.espacios
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-2 spainhn-bg-gris-cajas service-item html-container",
                                          staticStyle: { "flex-basis": "49%" },
                                        },
                                        [
                                          _c("h5", { staticClass: "fw-bold" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "default.SERVICES.SPACES"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.micrositeData
                                                  .webMiceDescription
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.museo
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-2 spainhn-bg-gris-cajas service-item html-container",
                                          staticStyle: { "flex-basis": "49%" },
                                        },
                                        [
                                          _c("h5", { staticClass: "fw-bold" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "default.SERVICES.MUSEUM"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.micrositeData
                                                  .webMuseumDescription
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.restaurante
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-2 spainhn-bg-gris-cajas service-item html-container",
                                          staticStyle: { "flex-basis": "49%" },
                                        },
                                        [
                                          _c("h5", { staticClass: "fw-bold" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "default.SERVICES.RESTAURANT"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.micrositeData
                                                  .webRestauranteDescription
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.alojamiento
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "p-2 spainhn-bg-gris-cajas service-item html-container",
                                          staticStyle: { "flex-basis": "49%" },
                                        },
                                        [
                                          _c("h5", { staticClass: "fw-bold" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "default.SERVICES.ACOMMODATIONS"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.micrositeData
                                                  .webHostingDescription
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "d-md-flex d-none" },
                        [
                          _c("MultimediaComponent", {
                            class: { "d-none": !_vm.videoId },
                            attrs: { "video-id": _vm.videoId },
                          }),
                        ],
                        1
                      ),
                      _vm.restaurantes.length > 0 && _vm.actividades.length > 0
                        ? _c("div", { staticClass: "text-start pt-1" }, [
                            _c(
                              "strong",
                              {
                                staticClass:
                                  "spainhn-sections-title text-start text-uppercase",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "default.MICROSITES_SERVICES_RECOMMENDATIONS"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm.restaurantes.length > 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-md-start mb-0 spainhn-subheader-info text-uppercase",
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "default.MICROSITES_RESTAURANT_RECOMMENDATIONS"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column flex-md-row mb-0",
                                },
                                _vm._l(
                                  _vm.restaurantes,
                                  function (restaurante, index) {
                                    return _c("cards-thumbnails", {
                                      key: index,
                                      class: { "d-none": index > 2 },
                                      attrs: {
                                        monument: restaurante.webName,
                                        nombreUrl: restaurante._id,
                                        tipo: "restaurantes",
                                        imageUrl: `${_vm.imagenesUrl}/restaurantes/${restaurante.oldId}/${restaurante.banner}`,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _c(
                                "mdb-btn",
                                {
                                  staticClass: "spainhn-button mt-3",
                                  class: {
                                    "d-none": !(_vm.restaurantes.length > 3),
                                  },
                                  attrs: { color: "indigo" },
                                  on: { click: _vm.goToRestaurantes },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "default.MICROSITES_RESTAURANT_BUTTON"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.actividades.length > 0
                        ? _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-md-start spainhn-subheader-info text-uppercase",
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "default.MICROSITES_ACTIVITIES_RECOMMENDATIONS"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex mb-0 pt-2 flex-column flex-md-row",
                                },
                                _vm._l(
                                  _vm.actividades,
                                  function (actividad, index) {
                                    return _c("cards-thumbnails", {
                                      key: index,
                                      class: { "d-none": index > 2 },
                                      attrs: {
                                        monument: actividad.webName,
                                        nombreUrl: actividad._id,
                                        tipo: "actividades",
                                        imageUrl: `${_vm.imagenesUrl}/actividades/${actividad.oldId}/${actividad.banner}`,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _c(
                                "mdb-btn",
                                {
                                  staticClass: "spainhn-button mt-3",
                                  class: {
                                    "d-none": !(_vm.actividades.length > 3),
                                  },
                                  attrs: { color: "indigo" },
                                  on: { click: _vm.goToActividades },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "default.MICROSITES_ACTIVITIES_BUTTON"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paquetes.filter(
                        (p) => p.tipo_de_paquete === "pack_experiencias"
                      ).length > 0
                        ? _c("div", { staticClass: "text-start pt-1" }, [
                            _c(
                              "strong",
                              { staticClass: "spainhn-subtitle-black" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("default.MICROSITES_PACKAGES"))
                                ),
                              ]
                            ),
                            _c("div", {
                              staticClass: "w-100 border-bottom mb-3",
                              staticStyle: {
                                height: "2vh",
                                "border-color":
                                  "var(--spainhn-rojo-corporativo) !important",
                                "border-width": "medium !important",
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm.paquetes.filter(
                        (p) => p.tipo_de_paquete === "pack_experiencias"
                      ).length > 0
                        ? _c(
                            "div",
                            [
                              _c("p", { staticClass: "text-md-start mb-0" }, [
                                _c(
                                  "strong",
                                  {
                                    staticStyle: {
                                      color: "rgb(150,150,150)",
                                      "font-weight": "600",
                                      "font-size": "24pt",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "default.MICROSITES_EXPERIENCES_PACKAGES"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column flex-md-row mb-0",
                                },
                                _vm._l(
                                  _vm.paquetes.filter(
                                    (p) =>
                                      p.tipo_de_paquete === "pack_experiencias"
                                  ),
                                  function (paquete, index) {
                                    return _c("cards-thumbnails", {
                                      key: index,
                                      class: { "d-none": index > 2 },
                                      attrs: {
                                        monument:
                                          paquete.nombre || paquete.webName,
                                        nombreUrl: paquete._id,
                                        tipo: "Entrada",
                                        imageUrl: `${_vm.imagenesUrl}/paquetes_prestadores/${paquete.oldId}/${paquete.banner}`,
                                      },
                                      on: {
                                        goTo: () => _vm.goToPaquete(paquete),
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _c(
                                "mdb-btn",
                                {
                                  staticClass: "spainhn-button mt-3",
                                  class: {
                                    "d-none": !(_vm.restaurantes.length > 3),
                                  },
                                  attrs: { color: "indigo" },
                                  on: { click: _vm.goToRestaurantes },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "default.MICROSITES_RESTAURANT_BUTTON"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-column pt-3 h-100 col-12 order-md-last col-xxl-4 d-none d-lg-flex d-xl-none",
                    class: { "d-none": _vm.eventosRecomendados.length == 0 },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-grow spainhn-bg-gris-cajas ps-4 pe-4 mt-2 pt-3 d-flex flex-column text-start spainhn-text",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "d-flex spainhn-sections-title" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("default.MICROSITES_LOCATION"))
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "spainhn-text" }, [
                          _vm._v(_vm._s(_vm.address)),
                        ]),
                        _c(
                          "div",
                          { staticClass: "spinhn-text text-start fw-bold" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("default.MICROSITES_INDICATIONS")) +
                                ":"
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "spinhn-text text-start" }, [
                          _c("p", {
                            staticStyle: {
                              "font-family": "Montserrat !important",
                              "font-size": "12pt !important",
                              "font-weight": "400 !important",
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.micrositeData.webDirections
                              ),
                            },
                          }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("MultimediaComponent", {
                          class: { "d-none": _vm.videoId },
                          attrs: { "video-id": _vm.videoId },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _c("welcome-modal", {
            attrs: {
              "popup-start": _vm.showWelcome,
              title: _vm.welcomeTitle,
              subtitle: _vm.welcomeSubtitle,
              "image-url": _vm.welcomeData.imageUrl,
              color: "danger",
            },
            on: {
              close: function ($event) {
                _vm.showWelcome = false
              },
              goTo: () =>
                _vm.$router.push(
                  `/castillos/tarifas/${_vm.$route.params.monumentoNombre}/${_vm.welcomeData.visitaId}`
                ),
            },
          }),
        ],
        1
      ),
      _c(
        "mdb-container",
        { staticClass: "mt-3", attrs: { fluid: "" } },
        [_c("ComponentsCloud")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }